module.exports = __webpack_public_path__ + "static/media/gargoyle.5a64ed1d.svg";